import { Fragment, createElement, useCallback, useMemo } from 'react';
import { Dispatcher } from '@sitecore-search/core';
import { BaseWidgetContext } from '../WidgetContext.js';
import useBaseWidget from '../hooks/useBaseWidget.js';
const generateInstanceId = () => Math.random().toString(36).substring(2, 9);
const BaseWidgetContextProvider = ({ rfkId, entity, children }) => {
    const instanceId = useMemo(() => generateInstanceId(), []);
    const dispatch = useCallback((action) => Dispatcher.dispatch({
        ...action,
        payload: { rfkId, instanceId, entity, ...action.payload },
    }), [rfkId, entity, instanceId]);
    const value = useMemo(() => ({
        rfkId,
        instanceId,
        dispatch,
        entity,
    }), [rfkId, dispatch, entity, instanceId]);
    return createElement(BaseWidgetContext.Provider, {
        value,
    }, children);
};
const OptionalBaseWidgetContextProvider = (props) => {
    const { children } = props;
    const context = useBaseWidget();
    // if it was already defined, just render children
    if (context?.rfkId === props.rfkId) {
        return createElement(Fragment, {}, children || null);
    }
    return createElement(BaseWidgetContextProvider, props, children);
};
export default OptionalBaseWidgetContextProvider;
